<template>
  <v-app>
    <v-card flat style="background-color: transparent;" v-if="jwt && userData.isAdmin">
      <Menu/>

      <v-content>
        <router-view></router-view>
      </v-content>
    </v-card>
    <Login v-else></Login>
  </v-app>
</template>

<script>
import jwtDecode from "jwt-decode";
import Menu from "./components/Menu";
import Login from "./components/Login";
export default {
  name: "App",
  components: {
    Menu,
    Login
  },
  data() {
    return {
      //
    };
  },
  computed: {
    jwt() {
      return this.$store.state.jwt;
    },
    userData() {
      if (this.jwt) {
        return jwtDecode(this.jwt);
      }
    }
  }
};
</script>

<style>
</style>